export const SearchPageResultsPlaceholderCard = () => {
	return (
		<div className="search-page-results-placeholder-card">
			<div className="search-page-results-placeholder-card-eyebrow placeholder-pulse"></div>
			<div className="search-page-results-placeholder-card-title placeholder-pulse"></div>
			<div className="search-page-results-placeholder-card-summary placeholder-pulse"></div>
		</div>
	);
};
